/* Usage

// hooks
import useWindowSize from 'src/hooks/useWindowSize'

function App() {
  const windowSize = useWindowSize();

  return (
    <div>
      {windowSize.width}px / {windowSize.height}px
    </div>
  );
}
*/

import {
  useState,
  useEffect
} from 'react';

// Hook
export default function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState<{
    width: number
    height: number
  }>({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state

      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });

      // Set for css
      const doc = document.documentElement
      doc.style.setProperty("--window-width", window.innerWidth + 'px');
      doc.style.setProperty("--window-height", window.innerHeight + 'px');

    }

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();



    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  const { width, height } = windowSize
  return { width, height }
}
